import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import BrokerClientDetails from '../BrokerClientDetails';
import store, { brokerClientActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';

const EditBrokerClientModal = () => {
    const { brokerClientState } = useSelector((state) => state);
    const { dispatch } = store;

    const handleClose = () =>
        dispatch(
            brokerClientActions.setBrokerClientOpen({
                openBrokerClientModal: false,
            })
        );

    const styles = {
        modal: {
            width: 800,
        },
    };

    return (
        <Dialog
            maxWidth='lg'
            open={brokerClientState.openBrokerClientModal}
            onClose={handleClose}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex='-1'
                    role='dialog'
                    style={styles.modal}
                >
                    <div
                        className='modal-dialog'
                        role='document'
                    >
                        <BrokerClientDetails />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default EditBrokerClientModal;
